// This file is intended to house logic related to generic Lyceum emotion CSS
// styles (https://emotion.sh/docs/object-styles). Generic meaning they could
// conceivably be heavily re-used by code in many domains, and there's no one
// specific area of our product they serve.

export const plainListCss = {
  margin: 0,
  padding: 0,
  "> li": {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
};

export const plainListCssShare = {
  margin: 0,
  padding: 0,
  "> li": {
    listStyle: "none",
    margin: 20,
    padding: 0,
  },
};

export const flexboxAlignItemsCenterCss = {
  display: "flex",
  alignItems: "center",
};
